const GET_CLAIMS_FAILED = 'Claims/GET_CLAIMS_FAILED';
const GET_GW_CLAIMS_FAILED = 'Claims/GET_GW_CLAIMS_FAILED';
const CREATE_CLAIM_FAILED = 'Claims/CREATE_CLAIM_FAILED';
const UPDATE_CLAIM_FAILED = 'Claims/UPDATE_CLAIM_FAILED';
const CREATE_SHELL_CLAIM_FAILED = 'Claims/CREATE_SHELL_CLAIM_FAILED';
const SET_POLICY_DETAILS_ERROR = 'PolicyDetails/SET_POLICY_DETAILS_ERROR';
export const CREATE_UBER_VOUCHER = 'Uber/CREATE_UBER_VOUCHER_FAILED';
export const ENTERPRISE_SEARCH_LOCATIONS = 'Enterprise/ENTERPRISE_SEARCH_LOCATIONS_FAILED';
export const VALIDATE_LOGGEDIN = 'Authentication/VALIDATE_LOGGEDIN_FAILED';
export const AUDATARGET_SEARCH_VENDOR = 'Audatarget/AUDATARGET_SEARCH_VENDOR_FAILED';
const AUDATARGET_GET_AVAILABILITY_FAILED = 'Audatarget/AUDATARGET_GET_AVAILABILITY_FAILED';
const AUDATARGET_BOOK_APPOINTMENT_FAILED = 'Audatarget/AUDATARGET_BOOK_APPOINTMENT_FAILED';
export const AUDATARGET_GET_VEHICLE_IMAGE_FAILED = 'Audatarget/AUDATARGET_GET_VEHICLE_IMAGE_FAILED';
export const AUDATARGET_VEHICLE_IMAGE_SYSTEM_FAILED = 'Audatarget/AUDATARGET_VEHICLE_IMAGE_SYSTEM_FAILED';
export const ENTERPRISE_OR_VENDOR_LOCATOR_FAILED = 'ENTERPRISE_OR_VENDOR_LOCATOR_FAILED';

export const NOT_DEFAULT_ERROR_POP_UP = [
  ENTERPRISE_SEARCH_LOCATIONS,
  AUDATARGET_SEARCH_VENDOR,
];

export const SAVE_ERRORS = [
  UPDATE_CLAIM_FAILED,
  AUDATARGET_SEARCH_VENDOR,
  AUDATARGET_GET_AVAILABILITY_FAILED,
  AUDATARGET_BOOK_APPOINTMENT_FAILED,
  AUDATARGET_VEHICLE_IMAGE_SYSTEM_FAILED,
  ENTERPRISE_OR_VENDOR_LOCATOR_FAILED,
];

export const NO_SAVE_ERRORS = [
  CREATE_SHELL_CLAIM_FAILED,
  SET_POLICY_DETAILS_ERROR,
  GET_CLAIMS_FAILED,
  GET_GW_CLAIMS_FAILED,
  CREATE_CLAIM_FAILED,
  AUDATARGET_GET_VEHICLE_IMAGE_FAILED,
];
